import React from 'react';
import { C } from '../constants/theme';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, Tag, Layers, Package, Layout,
  Radio, Users, Satellite
} from 'lucide-react';

export const NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'category', label: 'Content Category', icon: Tag },
  { key: 'viewtype', label: 'View Type', icon: Layers },
  { key: 'container', label: 'Container Master', icon: Package },
  { key: 'layout', label: 'Master Layout', icon: Layout },
  { key: 'feedProvider', label: 'Content Provider', icon: Radio },
  { key: 'users', label: 'User Management', icon: Users },
];

export function Sidebar({ active, onNav, collapsed }) {
  const { user } = useAuth();

  const initials = user?.firstName
    ? `${user.firstName} ${user.lastName || ''}`.trim()
      .split(' ')
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase()
    : 'U';

  const fullName = user
    ? `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.userName
    : 'Guest';

  return (
    <div style={{
      width: collapsed ? 64 : 224,
      background: C.white,
      borderRight: `1px solid ${C.border}`,
      height: '100vh',
      position: 'fixed',
      left: 0,
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      transition: 'width .25s',
      overflow: 'hidden',
      zIndex: 100,
    }}>

      {/* Logo */}
      <div style={{
        padding: '18px 16px',
        borderBottom: `1px solid ${C.border}`,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: collapsed ? '0' : '0 20px' }}>
          {collapsed && (
            <div style={{
              width: 40, height: 40, borderRadius: 10,
              overflow: 'hidden', flexShrink: 0,
            }}>
              <img
                src="https://api.mobinity.in/file-uploads/image/nubit_logo.png"
                alt="N"
                style={{
                  height: 36,
                  width: 'auto',
                  objectFit: 'cover',
                  objectPosition: 'left center',
                }}
              />
            </div>
          ) }
          {!collapsed && (

            <img
              src="https://api.mobinity.in/file-uploads/image/nubit_logo.png"
              alt="Logo"
              style={{ height: 32, objectFit: 'contain' }}
            />
          )}
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '12px 8px', overflowY: 'auto' }}>
        {NAV_ITEMS.map((item) => {
          const isActive = active === item.key;
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              onClick={() => onNav(item.key)}
              title={collapsed ? item.label : undefined}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '10px 12px',
                borderRadius: 8,
                border: 'none',
                cursor: 'pointer',
                background: isActive ? C.primary : 'transparent',
                color: isActive ? '#fff' : C.textMuted,
                marginBottom: 2,
                transition: 'all .15s',
                textAlign: 'left',
                fontFamily: 'inherit',
              }}
              onMouseEnter={(e) => {
                if (!isActive) e.currentTarget.style.background = '#F5F3FC';
              }}
              onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.background = 'transparent';
              }}
            >
              <Icon
                size={18}
                strokeWidth={isActive ? 2.2 : 1.8}
                color={isActive ? '#fff' : C.textMuted}
                style={{ flexShrink: 0 }}
              />
              {!collapsed && (
                <span style={{
                  fontSize: 13,
                  fontWeight: isActive ? 600 : 400,
                  whiteSpace: 'nowrap',
                }}>
                  {item.label}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* User Footer */}
      <div style={{
        padding: collapsed ? '12px 8px' : 14,
        borderTop: `1px solid ${C.border}`,
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '8px 10px',
          borderRadius: 8,
          background: '#F5F3FC',
        }}>
          <div style={{
            width: 30, height: 30, borderRadius: '50%',
            background: C.primary,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 700, fontSize: 11, flexShrink: 0,
          }}>
            {initials}
          </div>
          {!collapsed && (
            <div style={{ minWidth: 0 }}>
              <div style={{
                color: C.text, fontSize: 12, fontWeight: 600,
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {fullName}
              </div>
              <div style={{
                color: C.textMuted, fontSize: 11,
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {user?.userEmail || ''}
              </div>
            </div>
          )}
        </div>
      </div>

    </div>
  );
}